"use client";
import React, { ReactElement, ReactNode, useState } from "react";
import { AlertColor } from "@mui/material";
import { SnackbarOrigin } from "@mui/material/Snackbar";
import { GenericSnackbar } from "@/common/genericSnackbar";

interface SnackbarState extends SnackbarOrigin {
  open: boolean;
  autoHideDuration: number | null;
  icon: ReactNode | null;
}

type SnackbarContextValue = {
  state: SnackbarState;
  alertMessage: string | ReactElement;
  severityAlertMessage: AlertColor;
  show: (
    snackbarState: SnackbarState,
    alertMessage: string | ReactElement,
    severityAlertMessage: AlertColor,
    snackbarIndex?: number,
    actionElement?: ReactElement,
  ) => void;
  actionElement?: ReactElement;
  close: () => void;
};

export const SnackbarContext = React.createContext<SnackbarContextValue>({
  state: {
    open: false,
    vertical: "top",
    horizontal: "center",
    autoHideDuration: 5000,
    icon: null,
  },
  actionElement: <></>,
  alertMessage: "",
  severityAlertMessage: "info",
  show: () => {
    return true;
  },
  close: () => {
    return true;
  },
});
SnackbarContext.displayName = "SnackbarContext";

export const SnackbarProvider = ({ children }: any) => {
  const [state, setState] = useState<SnackbarState>({
    open: false,
    vertical: "top",
    horizontal: "center",
    autoHideDuration: 5000,
    icon: null,
  });
  const [state2, setState2] = useState<SnackbarState>({
    open: false,
    vertical: "top",
    horizontal: "center",
    autoHideDuration: 5000,
    icon: null,
  });
  const [alertMessage, setAlertMessage] = useState<string | ReactElement>("");
  const [severityAlertMessage, setSeverityAlertMessage] =
    useState<AlertColor>("info");

  const [alertMessage2, setAlertMessage2] = useState<string | ReactElement>("");
  const [severityAlertMessage2, setSeverityAlertMessage2] =
    useState<AlertColor>("info");

  const [actionElement, setActionElement] = useState<ReactElement | undefined>(
    <></>,
  );

  return (
    <SnackbarContext.Provider
      value={{
        state: state,
        alertMessage: alertMessage,
        severityAlertMessage: severityAlertMessage,
        actionElement,
        show: (
          state: SnackbarState,
          alertMessage: string | ReactElement,
          severityAlertMessage: AlertColor,
          snackbarIndex?: number,
          actionElement?: ReactElement,
        ) => {
          if (snackbarIndex === 1) {
            setState2(state);
            setAlertMessage2(alertMessage);
            setSeverityAlertMessage2(severityAlertMessage);
            return;
          }

          setState(state);
          setAlertMessage(alertMessage);
          setSeverityAlertMessage(severityAlertMessage);
          setActionElement(actionElement);
        },
        close: () => {
          setState((it) => {
            return {
              ...it,
              open: false,
            };
          });
        },
      }}
    >
      {children}
      <GenericSnackbar
        message={alertMessage}
        severity={severityAlertMessage}
        state={state}
        setState={setState}
        actionElement={actionElement}
      ></GenericSnackbar>
      <GenericSnackbar
        message={alertMessage2}
        severity={severityAlertMessage2}
        state={state2}
        setState={setState2}
        actionElement={actionElement}
      ></GenericSnackbar>
    </SnackbarContext.Provider>
  );
};
